import { render } from "./Regras.vue?vue&type=template&id=b1b11f4c&scoped=true"
import script from "./Regras.vue?vue&type=script&lang=js"
export * from "./Regras.vue?vue&type=script&lang=js"

import "./Regras.vue?vue&type=style&index=0&id=b1b11f4c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b11f4c"]])

export default __exports__